import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { IconResolver, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TariffStore } from './tariff';
import { filter, Subscription } from 'rxjs';
import { LayoutService } from './cms/service/layout.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    imports: [CommonModule, RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    host: {
        class: 'bg-white',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
    private _router = inject(Router)
    private _layoutService = inject(LayoutService)
    private _tariffStore = inject(TariffStore)
    private _sub?: Subscription;

    constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
        const resolver: IconResolver = (name) => sanitizer.bypassSecurityTrustResourceUrl(`/icons/saferyou_${name}.svg`);
        iconRegistry.addSvgIconResolver(resolver);
    }

    ngOnInit(): void {
        this._tariffStore.init();
        this._sub = this._router.events.pipe(filter((ev) => ev instanceof NavigationEnd)).subscribe((navEnd) => {
            this._tariffStore.isTariffRoute$.set(environment.tariff.routes.includes((navEnd as NavigationEnd).urlAfterRedirects));
            this._layoutService.closeNav();
        });
    }

    ngOnDestroy(): void {
        this._sub?.unsubscribe();
    }
}
